import {
	IonAlert,
	IonButton,
	IonCard,
	IonCardContent,
	IonIcon,
	useIonToast,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { add, settings, create, trashOutline, home } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WithFab from "../../hoc/with-fab";
import WithNavigation from "../../hoc/with-navigation";
import { useHome } from "../../store/home";

import "./styles.css";
import { useSystem } from "../../store/system";
import { WithLoader } from "../../hoc/with-loader";


const Home: React.FC = () => {
	const history = useHistory();

	const homeStore = useHome();
	const systemStore = useSystem();
	const { t } = useTranslation();

	const fabActions = [
		{
			icon: settings,
			onClick: () => history.push("/settings"),
		},
	];

	const loading =
		homeStore.systemCollectionReqInfo.pending ||
		systemStore.createReqInfo.loading;

	const id = homeStore.defaultSystem?.name;

	// const [present, dismiss] = useIonToast();

	useEffect(() => {
		homeStore.loadObjects();
	}, [systemStore.createReqInfo?.success]);

	// useEffect(() => {
	// 	const deletedName = homeStore.deleteSuccess;
	// 	if (deletedName) {
	// 		dismiss().then(() =>
	// 			present({
	// 				message: `${deletedName} deleted successfully`,
	// 				duration: 3000,
	// 			})
	// 		);
	// 		homeStore.resetDeleted();
	// 	}
	// }, [homeStore.deleteSuccess]);

	// const [systemToDelete, setSystemToDelete] = useState<string | null>(null);

	// const deleteSystemHandler = () => homeStore.delete(systemToDelete);

	// const confirmDelete = (sysId) => (e) => {
	// 	e.stopPropagation();
	// 	setSystemToDelete(sysId);
	// };

	useEffect(() => {
		if (homeStore.systemCollection && homeStore.systemCollection.length <= 0) {
			systemStore.create("_defaultSys", null, null);
		}
	}, [homeStore.systemCollection]);

	return (
		<>
			{/* <IonAlert
				isOpen={!!systemToDelete}
				onDidDismiss={() => setSystemToDelete(null)}
				cssClass="confirm-delete"
				header={"Delete this system?"}
				message={"This <strong>can't</strong> be undone!"}
				buttons={[
					{
						text: "Cancel",
						role: "cancel",
						cssClass: "secondary",
						handler: () => setSystemToDelete(null),
					},
					{
						text: "Okay",
						handler: deleteSystemHandler,
					},
				]}
			/> */}
			<WithNavigation preventGoBack={true} showLogo={true}>
				<WithLoader isLoading={loading}>
					<WithFab buttons={fabActions}>
						{homeStore.defaultSystem && (
							<>
								<div className="actions">
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/propulsion`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.propulsion.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/tow-cable`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.towCable.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/guinches`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.guinches.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/trawl-gates`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.trawlGates.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/trawl-systems`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.trawlSystems.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/flotation`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.flotation.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/system/${id}/cloths`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.cloths.title")}</span>
									</IonButton>
									<IonButton
										id="confirm-key-button"
										className="system-view-btn"
										expand="block"
										color="dark"
										fill="clear"
										onClick={() => history.push(`/faq`)}
										disabled={false}
									>
										<span className="btn-label">{t("system.faq.title")}</span>
									</IonButton>
								</div>
								<div className="logo-container">
									<img
										src="/assets/powered-by.png"
										alt="Powered by Acruxsoft"
									/>
								</div>
							</>
						)}
					</WithFab>
				</WithLoader>
			</WithNavigation>
		</>
	);
};

export default Home;
